// API configuration
export const baseApiUrl = import.meta.env.VITE_API_BASE_URL || '';
